import * as actionTypes from '../actions/actionTypes';

const initialState = {
    dealer: null,
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.ADD_DEALER_INITIALIZE:
            return {
                ...state,
                loading: null,
                error: null,
                dealer: null
            };
        case actionTypes.ADD_DEALER_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                dealer: null
            };
        case actionTypes.ADD_DEALER_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                dealer: null
            };
        case actionTypes.ADD_DEALER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                dealer: action.payload
            };
        default:
            return state;
    }
};

export default reducer;